import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import Lottie from 'react-lottie';
import { Button, Card, FileInput, FormGroup, InputGroup, Icon, MenuItem } from '@blueprintjs/core';
import { Select } from "@blueprintjs/select";
import { L10n, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { ColumnDirective, ColumnsDirective, Filter, GridComponent, Group, Inject, Page, PageSettingsModel, Sort } from '@syncfusion/ej2-react-grids';
import "moment/locale/pt-br"
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-calendars/styles/material.css";
import "@syncfusion/ej2-dropdowns/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import "@syncfusion/ej2-react-grids/styles/material.css";

import { IconeHome } from '../../Assets';
import { SignIn as ContextSignIn } from '../../Context';
import * as LottieFiles from '../../Data/Lottie';
import { CentroDeCusto, D4sign, NFSe } from '../../Services/Controllers';
import { Objeto } from '../../Services/Models';
import { NotificacaoInterna } from '../../Services/Notification';

import * as Component from './style';
import viewModel from './viewModel';
import moment from 'moment';

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const PropriedadesDeCalendario = {
        months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        weekdaysShort: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
    };
    const [getFormularioAnexoPlanilha, setFormularioAnexoPlanilha] = useState<File>();
    const [getItemPickerCentroDeCusto, setItemPickerCentroDeCusto] = useState<Objeto.CentroDeCusto>();
    const [getListaPickerCentroDeCusto, setListaPickerCentroDeCusto] = useState<Array<Objeto.CentroDeCusto>>([]);
    const PickerCentroDeCusto = Select.ofType<Objeto.CentroDeCusto>();
    const [getPlanilhaImportada, setPlanilhaImportada] = useState<{ pdf: string, tabelaOrignal: Array<any>, nfs: Array<Objeto.NFSe> }>();
    const [getFormularioAssistenteFinanceiroEmail, setFormularioAssistenteFinanceiroEmail] = useState<string>("");
    const [getFormularioGerenteFinanceiroEmail, setFormularioGerenteFinanceiroEmail] = useState<string>("");
    const [getPlanilhaSendoImportada, setPlanilhaSendoImportada] = useState<boolean | undefined>();
    const [getEnviandoContratoParaAssinatura, setEnviandoContratoParaAssinatura] = useState<boolean>(false);
    const [getEncaminhandoNF, setEncaminhandoNF] = useState<boolean>(false);
    const History = useHistory();
    /* #endregion */

    /* Sobre esta função *//**
       * Executa todas as rotinas atrealadas a alteração do centro de custo exibido na página
       * @param {Objeto.CentroDeCusto | undefined} Item Informe o objeto referente ao centro de custo
       * @param {MapaExibido} MapaExibido Informe se o mapa está exibido (condição necessária por causa do delay do usestate)
       **/
    async function Buscar() {
        if (!getItemPickerCentroDeCusto) {
            NotificacaoInterna.ExibirNotificacao("Empreendimento não selecionada", "Informe o empreendimento", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return false;
        }
        if (!getFormularioAnexoPlanilha) {
            NotificacaoInterna.ExibirNotificacao("Planilha não selecionada", "Informe a palnilha a ser importada", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return;
        }
        await setPlanilhaSendoImportada(true);
        let Response = await NFSe.ImportarPlanilha(ContextSignIn.getContext().token, getItemPickerCentroDeCusto.empresa.id, getItemPickerCentroDeCusto.sigla, { Nome: "Planilha de comissão.xls", Conteudo: getFormularioAnexoPlanilha });

        await setPlanilhaImportada(Response.data);
        await setPlanilhaSendoImportada(false);
    }
    async function EncaminharDocumentoParaAssinatura(): Promise<void> {
        if (!getFormularioGerenteFinanceiroEmail && !getFormularioAssistenteFinanceiroEmail) {
            NotificacaoInterna.ExibirNotificacao("Nenhum email informado", "Informe ao menos um email para enviar parra assinatura", NotificacaoInterna.TipoDeNotificacao.Erro);
            return;
        }

        await setEnviandoContratoParaAssinatura(true);
        let Response = await D4sign.SubmeterNFSe(ContextSignIn.getContext().token, "AMAZONAS SHOPPING", {
            AssistenteFinanceiroEmail: getFormularioAssistenteFinanceiroEmail,
            GerenteFinanceiroEmail: getFormularioGerenteFinanceiroEmail,
            Anexo: {
                descricao: "Planilha de comissão",
                extensao: "pdf",
                arquivo: getPlanilhaImportada?.pdf
            }

        } as any);
        if (Math.floor(Response.status / 100) == 2) {
            NotificacaoInterna.ExibirNotificacao("NFSe devidamente enviada para assinatura", "O(s) documento(s) se encontra no D4sign para assinatura'", NotificacaoInterna.TipoDeNotificacao.Sucesso);
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Falha ao enviar o NFSe para assinatura", (Response.data.toString() != "[object Object]") ? Response.data.toString() : "😱 Houve uma falha ao enviar a NFSe para assinatura, entre em contato com a equipe de desenvolvimento", NotificacaoInterna.TipoDeNotificacao.Erro);
        }
        await setEnviandoContratoParaAssinatura(false);
    };
    async function EncaminharNF(): Promise<void> {

        if (getPlanilhaImportada?.nfs != undefined) {
            await setEncaminhandoNF(true);
            let Response = await NFSe.Post(ContextSignIn.getContext().token, getPlanilhaImportada?.nfs);
            if (Math.floor(Response.status / 100) == 2) {
                NotificacaoInterna.ExibirNotificacao("NF(s) devidamente gerada(s)", "Cada nota fiscal informada na planilha foi enviada para o tomador conforme o email informado'", NotificacaoInterna.TipoDeNotificacao.Sucesso);
            }
            else {
                NotificacaoInterna.ExibirNotificacao("Falha ao gerar NFS", (Response.data.toString() != "[object Object]") ? Response.data.toString() : "😱 Houve uma falha ao gerar a(s) NF(s), entre em contato com a equipe de desenvolvimento", NotificacaoInterna.TipoDeNotificacao.Erro);
            }
            await setEncaminhandoNF(false);
        }
        else {
            console.log(getPlanilhaImportada)
        }

    };
    useEffect(() => {
        async function componentDidMount() {
            await setListaPickerCentroDeCusto((await CentroDeCusto.Get(ContextSignIn.getContext().token, "VENDA")).data ?? []);
        }
        componentDidMount();
    }, []);
    L10n.load({
        'pt-BR': {
            'grid': {
                'EmptyDataSourceError': 'A fonte de dados não deve estar vazia no primeiro carregamento',
                'EmptyRecord': 'Nenhum registro exibido',
                'GroupDropArea': 'Arraste um cabeçalho de coluna aqui para agrupar sua coluna',
                'Item': 'Item',
                'Items': 'Itens',
                'UnGroup': 'Clique para desagrupar',
                "True": "Verdadeiro",
                "False": "falso",
                "InvalidFilterMessage": "Filtro inválido",
                "GroupDisable": "Agrupamento desativado para a coluna",
                "FilterbarTitle": "Filtro de Célula",
                "Add": "Adicionar",
                "Edit": "Editar",
                "Cancel": "Cancelar",
                "Update": "Atualizar",
                "Delete": "Deletar",
                "Print": "Imprimir",
                "Pdfexport": "Exportar para PDF",
                "Excelexport": "Exportar para Excel",
                "Wordexport": "Exportar para Word",
                "Csvexport": "Exportar para CSV",
                "Search": "Pesquisar",
                "Columnchooser": "Colunas",
                "Save": "Salvar",
                "EditOperationAlert": "Nenhum registro selecionado para edição",
                "DeleteOperationAlert": "Nenhum registro selecionado para exclusão",
                "SaveButton": "Salvar",
                "OKButton": "OK",
                "CancelButton": "Cancelar",
                "EditFormTitle": "Detalhe de ",
                "AddFormTitle": "Novo recorde",
                "BatchSaveConfirm": "Você tem certeza de que deseja salvar suas alterações?",
                "BatchSaveLostChanges": "As alterações não salvas serão perdidas. Você tem certeza que quer continuar?",
                "ConfirmDelete": "Tem certeza que deseja excluir os registros?",
                "CancelEdit": "Tem certeza de que deseja desfazer as alterações?",
                "ChooseColumns": "Escolha a coluna",
                "SearchColumns": "Colunas de pesquisa",
                "Matchs": "Nenhum resultado encontrado",
                "FilterButton": "Filtro",
                "ClearButton": "Limpar",
                "StartsWith": "Começa com",
                "EndsWith": "Termina com",
                "Contains": "Contém",
                "Equal": "Igual a",
                "NotEqual": "Diferente de",
                "LessThan": "Menor que",
                "LessThanOrEqual": "Menor ou igual a",
                "GreaterThan": "Maior que",
                "GreaterThanOrEqual": "Maior ou igual que",
                "ChooseDate": "Escolha uma data",
                "EnterValue": "Insira o valor",
                "Copy": "Copiar",
                "Group": "Agrupar por esta coluna",
                "Ungroup": "Separe desta coluna",
                "autoFitAll": "Ajustar automaticamente todas as colunas",
                "autoFit": "Ajustar automaticamente a esta coluna",
                "Export": "Exportar",
                "FirstPage": "Primeira página",
                "LastPage": "Última página",
                "PreviousPage": "Página anterior",
                "NextPage": "Próxima página",
                "SortAscending": "Ordem ascendente",
                "SortDescending": "Ordem decrescente",
                "EditRecord": "Editar registro",
                "DeleteRecord": "Apagar registro",
                "FilterMenu": "Filtro",
                "OK": "OK",
                "Filter": "Filtro",
                "Clear": "Limpar",
                "SelectAll": "Selecionar tudo",
                "Blanks": "Em branco",
                "FilterTrue": "Verdadeiro",
                "FilterFalse": "Falso",
                "NoResult": "Nenhum resultado encontrado",
                "ClearFilter": "Filtro Limpo",
                "NumberFilter": "Número de filtros",
                "TextFilter": "Filtros de texto",
                "DateFilter": "Filtros de data",
                "MatchCase": "Minúsculas/Maiúsculas",
                "Between": "Entre",
                "CustomFilter": "Filtro customizado",
                "CustomFilterPlaceHolder": "Insira o valor",
                "CustomFilterDatePlaceHolder": "Escolha uma data",
                "AND": "E",
                "OR": "Ou",
                "ShowRowsWhere": "Mostrar linhas onde:"
            },
            'pager': {
                'currentPageInfo': '{0} de {1} paginas',
                'totalItemsInfo': '({0} postagens)',
                'firstPageTooltip': 'Para a primeira página',
                'lastPageTooltip': 'Para a última página',
                'nextPageTooltip': 'Para a próxima página',
                'nextPagerTooltip': 'Para a próxima página',
                'previousPageTooltip': 'Para a página anterior',
                'previousPagerTooltip': 'Para a página anterior',
            }
        }
    });
    setCulture("pt-BR");
    setCurrencyCode("BRL");

    return (
        <Component.Container>
            <div className="endereco">
                <img src={IconeHome} alt="" />
                <div className="bar">/</div>
                <div className="place">NFSe</div>
                <div className="bar">/</div>
                <div className="place">Planilha</div>
                <FormGroup className="place" labelFor="DataDeInicio" inline={true} style={{ marginTop: "15px", marginLeft: "10px" }}>
                    <FileInput style={{ width: "400px" }} inputProps={{ accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }} buttonText="Abrir" text={getFormularioAnexoPlanilha == undefined ? "Anexe a planilha de NFSe a ser importada" : getFormularioAnexoPlanilha.name} onInputChange={async (event: React.FormEvent<HTMLInputElement>) => {
                        if (event.currentTarget.files?.item(0)?.type.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") == true) {
                            await setFormularioAnexoPlanilha(event.currentTarget.files?.item(0) || { name: "" } as File);
                        }
                        else {
                            NotificacaoInterna.ExibirNotificacao("Formato de arquivo invalido", `Somente serão aceitos com extensão PDF`, NotificacaoInterna.TipoDeNotificacao.Erro);
                        }
                    }} onClick={(e: any) => (e.target.value = null)}/>
                    {getFormularioAnexoPlanilha && <Button type="submit" intent="none" style={{ marginLeft: "10px", marginTop: "5px", width: "80px" }} onClick={async () => {
                        await setFormularioAnexoPlanilha(undefined)
                    }}>Limpar</Button>}
                </FormGroup>
                <Icon icon="search" iconSize={25} style={{ cursor: "pointer", marginLeft: "15px" }} onClick={Buscar} />
            </div>
            <FormGroup style={{ position: "absolute", left: "20%", top: "0.5cm" }} label="" labelFor="" inline={true}>
                <PickerCentroDeCusto popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerCentroDeCusto} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                    itemRenderer={(Item: Objeto.CentroDeCusto) => <MenuItem onClick={async () => {
                        await setItemPickerCentroDeCusto(Item);
                        await setFormularioAnexoPlanilha(undefined);
                        await setPlanilhaImportada(undefined);
                        await setPlanilhaSendoImportada(undefined);
                        await setFormularioAssistenteFinanceiroEmail("");
                        await setFormularioGerenteFinanceiroEmail("");
                        await setEnviandoContratoParaAssinatura(false);
                        await setEncaminhandoNF(false);
                    }} text={Item.descricao} />} itemPredicate={(Texto: string, Item: Objeto.CentroDeCusto) => { return (Item.descricao ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                    <Button className="selector" style={{ background: "#DCDCDC", color: "#484848", border: "none", boxShadow: "none", borderRadius: "10px", outline: "none", width: "250px" }} text={getItemPickerCentroDeCusto?.descricao ?? "Selecione o empreendimento"} rightIcon="double-caret-vertical" />
                </PickerCentroDeCusto>
            </FormGroup>
            {getPlanilhaImportada == undefined && <div style={{ width: "100%", background: "0", display: "flex", flexDirection: "column" }}>
                <Lottie
                    options={{
                        loop: true,
                        autoplay: true,
                        animationData: LottieFiles.LoadTable,
                        rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                        }
                    }}
                    height={450}
                    width={500}
                    style={{ marginTop: "122px", marginBottom: "50px" }}
                />
                <div className="loading" style={{ margin: "-100px auto 0 auto", fontWeight: "bold" }}>{(getItemPickerCentroDeCusto == undefined) ? "Por favor, selecione um empreendimento" : (getFormularioAnexoPlanilha == undefined ? "Por favor, selecione a planilha a ser importada" : (getPlanilhaSendoImportada == undefined ? "Clique no icone de busca para importar a planilha" : ((getPlanilhaSendoImportada == false) ? "Aguarde, estamos importando a planilha" : "Pronto, sua planilha foi importada com sucesso!")))}</div>
            </div>}
            {getPlanilhaImportada != undefined && <Card style={{ width: "88%", backgroundColor: "#ffffff", margin: "0 auto", borderRadius: "5px", boxShadow: "none", padding: "40px 3% 40px 3% " }} >
                <Component.ContentCard>
                    <Component.Title>
                        <Icon icon={"join-table"} style={{ cursor: "pointer", marginLeft: "30px" }} iconSize={20} />
                        <h3>Planilha de importação</h3>
                    </Component.Title>
                    <GridComponent allowFiltering={true} allowPaging={true} filterSettings={{ type: "Excel" }} dataSource={getPlanilhaImportada ? getPlanilhaImportada.tabelaOrignal : []} pageSettings={{ pageSize: 6 }} sortSettings={{
                        columns: [
                            { field: "Cliente", direction: "Ascending" }
                        ]
                    }} style={{ marginTop: "25px", borderColor: "transparent" }}>
                        <ColumnsDirective>
                            <ColumnDirective field="TomadorRazaoSocial" headerText="Tomador: razão social" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorNomeFantasia" headerText="Tomador: nome fantasia" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorCNPJ" headerText="Tomador: CNPJ" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorIE" headerText="Tomador: inscrição municipal" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorIM" headerText="Tomador: inscrição estadual" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorTelefone" headerText="Tomador: telefone" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorEmail" headerText="Tomador: email" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorLogradouro" headerText="Tomador: endereço" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorNumero" headerText="Tomador: nº end." width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorComplemento" headerText="Tomador: compl. end." width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorBairro" headerText="Tomador: bairro" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorCidade" headerText="Tomador: cidade" width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorUF" headerText="Tomador: UF end." width="300px" textAlign="Left" />
                            <ColumnDirective field="TomadorCEP" headerText="Tomador: CEP end." width="300px" textAlign="Left" />
                            <ColumnDirective field="DataDeEmissao" headerText="Dt. emissão" type="date" format="dd/MM/yyyy" width="300px" textAlign="Left" />
                            <ColumnDirective field="Vencimento" headerText="Dt. vencimento" type="date" format="dd/MM/yyyy" width="300px" textAlign="Left" />
                            <ColumnDirective field="Competencia" headerText="Dt. competência" type="date" format="dd/MM/yyyy" width="300px" textAlign="Left" />
                            <ColumnDirective field="Descricao" headerText="Descricão" width="300px" textAlign="Left" />
                            <ColumnDirective field="ValorDoServico" headerText="Valor do serviço" format="C2" width="300px" textAlign="Left" />
                            <ColumnDirective field="MeioDePagamento" headerText="Meio de pagamento" width="300px" textAlign="Left" />
                            <ColumnDirective field="MeioDePagamento" headerText="enviarNFePrestador" width="300px" textAlign="Left" />
                            <ColumnDirective field="ServicoInternacional" headerText="Serv. internacional?" width="300px" textAlign="Left" />
                            <ColumnDirective field="CidadeDoServico" headerText="Cidade do serviço" width="300px" textAlign="Left" />
                            <ColumnDirective field="UFServico" headerText="UF do serviço" width="300px" textAlign="Left" />
                            <ColumnDirective field="COFINS" headerText="COFINS" type="number" format="p" width="300px" textAlign="Left" />
                            <ColumnDirective field="COFINS" headerText="COFINS" type="number" format="p" width="300px" textAlign="Left" />
                            <ColumnDirective field="CSLL" headerText="CSLL" type="number" format="p" width="300px" textAlign="Left" />
                            <ColumnDirective field="INSS" headerText="INSS" type="number" format="p" width="300px" textAlign="Left" />
                            <ColumnDirective field="IR" headerText="IR" type="number" format="p" width="300px" textAlign="Left" />
                            <ColumnDirective field="ISS" headerText="ISS" type="number" format="p" width="300px" textAlign="Left" />
                            <ColumnDirective field="PIS" headerText="PIS" type="number" format="p" width="300px" textAlign="Left" />
                        </ColumnsDirective>
                        <Inject services={[Page, Sort, Filter, Group]} />
                    </GridComponent>
                    <div style={{ display: "flex" }}>
                        <Button type="submit" disabled={false} intent="primary" style={{ height: "30px", marginLeft: "30px", marginBottom: "35px", marginTop: "35px", width: "200px" }} onClick={EncaminharNF}>Gerar e encaminhar</Button>
                        {getEncaminhandoNF == true && <div style={{ width: 100, height: 100 }}>
                            <Lottie options={{ animationData: LottieFiles.Load, loop: true, autoplay: true, rendererSettings: { preserveAspectRatio: 'xMidYMid slice' } }} />
                        </div>}
                    </div>
                </Component.ContentCard>
                <Component.ContentCard >
                    <Component.Title>
                        <Icon icon={"edit"} style={{ cursor: "pointer" }} iconSize={20} />
                        <h3>Sobre as assinaturas necessárias</h3>
                    </Component.Title>
                    <FormGroup label="Assistente financeiro:" labelFor="AssistenteFinanceiroEmail" inline={true} >
                        <InputGroup id="AssistenteFinanceiroEmail" placeholder={"meunome@meudominio.com.br"} value={getFormularioAssistenteFinanceiroEmail}
                            style={{ width: "calc(27vw)" }} onChange={async (event: React.FormEvent<HTMLInputElement>) => {
                                await setFormularioAssistenteFinanceiroEmail(event.currentTarget.value ?? "");
                            }}>
                        </InputGroup>
                    </FormGroup>
                    <FormGroup label="Gerente financeiro:" labelFor="GerenteFinanceiroEmail" inline={true} >
                        <InputGroup id="GerenteFinanceiroEmail" placeholder={"meunome@meudominio.com.br"} value={getFormularioGerenteFinanceiroEmail}
                            style={{ width: "calc(27vw + 15px)" }} onChange={async (event: React.FormEvent<HTMLInputElement>) => {
                                await setFormularioGerenteFinanceiroEmail(event.currentTarget.value ?? "");
                            }}>
                        </InputGroup>
                    </FormGroup>
                    <div style={{ display: "flex" }}>
                        <Button type="submit" disabled={false} intent="primary" style={{ height: "30px", marginTop: "35px", marginBottom: "35px", width: "200px" }} onClick={EncaminharDocumentoParaAssinatura}>Submeter a assinatura</Button>
                        {getEnviandoContratoParaAssinatura == true && <div style={{ width: 100, height: 100 }}>
                            <Lottie options={{ animationData: LottieFiles.Load, loop: true, autoplay: true, rendererSettings: { preserveAspectRatio: 'xMidYMid slice' } }} />
                        </div>}
                    </div>
                </Component.ContentCard>
            </Card>}
        </Component.Container >
    );
    /* #endregion */
};

export default View;